import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/auth/SessionAuthInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/layout/GlobalNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/utils/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","GlobalErrorHandler"] */ "/vercel/path0/app/components/utils/NextJSErrorHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/components/utils/PWAAnalyticsInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccentColorProvider"] */ "/vercel/path0/app/contexts/AccentColorContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateFormatProvider"] */ "/vercel/path0/app/contexts/DateFormatContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LineSettingsProvider"] */ "/vercel/path0/app/contexts/LineSettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PillStyleProvider"] */ "/vercel/path0/app/contexts/PillStyleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentPagesProvider"] */ "/vercel/path0/app/contexts/RecentPagesContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TokenBalanceProvider"] */ "/vercel/path0/app/contexts/TokenBalanceContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TokenIncrementProvider"] */ "/vercel/path0/app/contexts/TokenIncrementContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/app/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DataProvider"] */ "/vercel/path0/app/providers/DataProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogRocketProvider"] */ "/vercel/path0/app/providers/LogRocketProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileProvider"] */ "/vercel/path0/app/providers/MobileProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/vercel/path0/app/providers/NotificationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/app/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/utils/detailedErrorLogging.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/utils/developmentErrorOverride.ts");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.2.0_next@15.4.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-pl_c7isvh5yvk6237uiufuzf4xjwq/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/leaflet@1.9.4/node_modules/leaflet/dist/leaflet.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.5_@babel+core@7.28.0_@opentelemetry+api@1.9.0_babel-plugin-macros@3.1.0_react-dom@1_6334gtu3fqjbrkbe3mmn7wg22u/node_modules/next/dist/client/script.js");
